<template>
  <div class="ma-4">
    <v-sheet v-show="showSkeleton" class="pa-3">
      <v-skeleton-loader class="mx-auto" type="table" />
    </v-sheet>
    <div class="text-h4 mb-2" v-show="!showSkeleton">Pesquisas de Satisfação</div>

     <v-dialog v-model="dialog">
      <v-card>
        <v-card-text>
          <Dialog  :pesquisa="pesquisa" />
        </v-card-text> 

        <v-divider />

        <v-card-actions>
        <v-spacer />
            <v-btn color="blue darken-1" text @click="dialog = false">Sair</v-btn>
        </v-card-actions> 
      </v-card>  
    </v-dialog>

    <v-data-iterator
      v-show="!showSkeleton"
      :no-data-text="noDataText"
      :items="dataPesquisaSatisfacao"
      :items-per-page.sync="itemsPerPage"
      :page="page"
      :search="search"
      :no-results-text="noResultsText"
      hide-default-footer
    >
      <template v-slot:header>
        <v-row>
          <v-col cols="7" class="my-2">
            <v-btn
              v-if="permissaoTotal"
              dark
              color="orangePcm"
              href="/pesquisa-satisfacao/cadastro/pesquisa-satisfacao/criar"
              target="_blank"
              @click="handleGoToNewPesquisaSatisfacao"
            >
              Criar Pesquisa de Satisfação
            </v-btn>
          </v-col>
          <v-col cols="4">
            <v-text-field v-model="search" clearable hide-details prepend-inner-icon="mdi-magnify" label="Busca" />
          </v-col>
        </v-row>
      </template>
      <template v-slot:default="props">
        <v-data-table
          dense
          :headers="headers"
          :items="props.items"
          hide-default-footer
          class="elevation-1"
          disable-pagination
          @dblclick:row="atualizar"
        >
          <template v-slot:[`item.botoes`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  small
                  dark
                  color="bluePcm"
                  class="ma-2"
                  target="_blank"
                  v-bind="attrs"
                  v-on="on"
                  @click="openDialog(item)"
                >
                  <v-icon>mdi-eye</v-icon>
                </v-btn>
              </template>
              <span>Uso</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  @click="atualizarButton(item, $event)"
                  small
                  dark
                  color="bluePcm"
                  v-bind="attrs"
                  v-on="on"
                  class="ma-2"
                  :href="`/pesquisa-satisfacao/cadastro/pesquisa-satisfacao/atualizar/${item._id}`"
                  target="_blank"
                >
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Editar</span>
            </v-tooltip>

            <v-tooltip bottom v-if="permissaoTotal">
              <template v-slot:activator="{ on, attrs }">
                <v-btn @click="deletar(item)" icon small dark color="darkRed" v-bind="attrs" v-on="on">
                  <v-icon>mdi-trash-can-outline</v-icon>
                </v-btn>
              </template>
              <span>Remover</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </template>

      <template v-slot:footer>
        <v-row class="mt-2" align="center" justify="center">
          <div class="ml-4 mb-2 grey--text">
            <p>Total Pesquisas de Satisfação: {{ qtdPesquisasSatisfacao }}</p>
          </div>
          <v-spacer />
          <div class="pb-5">
            <ListPagination
              :page="page"
              :numberOfPages="numberOfPages"
              @firstPage="firstPage"
              @formerPage="formerPage"
              @nextPage="nextPage"
              @lastPage="lastPage"
            />
          </div>
        </v-row>
      </template>
    </v-data-iterator>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import { registerVuexModule } from '@/utils/vuexUtils'
import ListPagination from '@/componentes/ListPagination'
import { pagesHomeMixins } from '@/mixins/pagesHomeMixins'
import { obtainUserPermissions } from '@/utils/obtainUserPermissions'

import pesquisaSatisfacaoStore from '../_store'
import pesquisaSatisfacaoHttpService from '../_services/pesquisaSatisfacaoHttpService'
import Dialog from '../_components/Dialog.vue'

export default {
  components: { ListPagination, Dialog },

  mixins: [pagesHomeMixins],

  data: () => ({
    headers: [
      {
        text: 'Pesquisa de Satisfação',
        value: 'description',
        align: 'left',
      },
      {
        text: 'Áudio Pesquisa',
        value: 'audioPesquisa',
        align: 'left',
        sortable: false,
      },
      {
        text: 'Ações',
        value: 'botoes',
        align: 'center',
        sortable: false,
      },
    ],
    dataPesquisaSatisfacao: [],
    permissaoTotal: false,
    arrayPermissoesTotal: [process.env.VUE_APP_PESQUISA_SATISFACAO_CADASTRO_TOTAL, process.env.VUE_APP_ADMINISTRADOR],
    dialog: false,
    pesquisa: {}
  }),

  computed: {
    ...mapGetters('pesquisaSatisfacaoHomeModulePesquisaSatisfacaoStore', ['getPesquisasSatisfacao', 'getAudios']),

    numberOfPages() {
      return Math.ceil(this.dataPesquisaSatisfacao.length / this.itemsPerPage)
    },
    qtdPesquisasSatisfacao() {
      return this.dataPesquisaSatisfacao.length
    },
  },

  async created() {
    this.showSkeleton = true

    registerVuexModule(this.$store, 'pesquisaSatisfacaoHomeModulePesquisaSatisfacaoStore', pesquisaSatisfacaoStore)

    await Promise.all([this.listarPesquisasSatisfacao(), this.listarAudios()])
    this.dataPesquisaSatisfacao = [...this.getPesquisasSatisfacao]

    this.getAudios.forEach(audio => {
      this.dataPesquisaSatisfacao.forEach(pesquisa => {
        if (audio._id === pesquisa.audioPesquisa) {
          pesquisa.audioPesquisa = audio.description
        }
      })
    })

    const arrayPermissions = this.arrayPermissionsFromLocalStorage()
    arrayPermissions.forEach(permissaoLocalStorage => {
      if (this.arrayPermissoesTotal.includes(permissaoLocalStorage)) {
        this.permissaoTotal = true
      }
    })

    this.showSkeleton = false
  },

  methods: {
    ...mapActions('pesquisaSatisfacaoHomeModulePesquisaSatisfacaoStore', ['listarPesquisasSatisfacao', 'listarAudios', 'listarPesquisaUse']),
    ...obtainUserPermissions,

    handleGoToNewPesquisaSatisfacao(event) {
      event.preventDefault()
      if (event.metaKey || event.ctrlKey) {
        const handleGoToNewPesquisaSatisfacao = this.$router.resolve({ name: 'cadastroPesquisa/criar' })
        window.open(handleGoToNewPesquisaSatisfacao.href, '_blank')
      } else {
        this.$router.push({ name: 'cadastroPesquisa/criar' })
      }
    },

    atualizar(event, item) {
      if (event.metaKey || event.ctrlKey) {
        const updatePath = this.$router.resolve(`pesquisa-satisfacao/atualizar/${item.item._id}`)
        window.open(updatePath.href, '_blank')
      } else {
        this.$router.push(`pesquisa-satisfacao/atualizar/${item.item._id}`)
      }
    },

    atualizarButton(item, event) {
      event.preventDefault()
      if (event.metaKey || event.ctrlKey) {
        const updatePath = this.$router.resolve(`pesquisa-satisfacao/atualizar/${item._id}`)
        window.open(updatePath.href, '_blank')
      } else {
        this.$router.push(`pesquisa-satisfacao/atualizar/${item._id}`)
      }
    },

    async deletar(item) {
      let resultado = window.confirm(`Deseja remover a pesquisa de satisfação "${item.description}"?`)
      if (resultado) {
        try {
          await pesquisaSatisfacaoHttpService.deletePesquisaSatisfacao(item._id)
          this.dataPesquisaSatisfacao = this.dataPesquisaSatisfacao.filter(x => x._id !== item._id)
        } catch (error) {
          alert(error.response.data)
        }
      }
    },
    async openDialog(pesquisa) {
      await this.listarPesquisaUse(pesquisa._id)
      this.pesquisa = pesquisa
      this.dialog = true
    }
  },
}
</script>
